import axios from "axios";
import { BASE_URL} from "./config";

// const API = axios.create({ baseURL: "https://skillop.in" });
const API = axios.create({ baseURL: BASE_URL });

const delExp = (expId) => {
    const token = localStorage.getItem("skilloptoken");
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
        },
        withCredentials: true,
    };
    return API.delete(`/api/user/remove/experence/${expId}`, config);
};

export default delExp;
